import { render, staticRenderFns } from "./TravelAgency.vue?vue&type=template&id=2037636b&"
import script from "./TravelAgency.vue?vue&type=script&lang=js&"
export * from "./TravelAgency.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports